import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";

import {
  HubCancelSubmitGroup,
  HubDialogContent,
  HubHookFormWrapper,
} from "../../components";
import {
  useGetWorkOrderRoutingGroup,
  usePostCreateSubRoute,
  usePutUpdateSubRouteGroup,
} from "../../hooks/index.js";
import { useDialogContext } from "../HubDialogWrapper/HubDialogWrapper.jsx";

import AddReworkRouteContentForm from "./AddReworkRouteContentForm.jsx";

const AddReworkRouteContent = ({ routeId, userId = null }) => {
  const { onClose = () => {}, open: groupId } = useDialogContext();
  const {
    mutate: create,
    isLoading: isCreateLoading,
    isSuccess: isCreateSuccess,
  } = usePostCreateSubRoute();
  const {
    mutate: update,
    isLoading: isUpdateLoading,
    isSuccess: isUpdateSuccess,
  } = usePutUpdateSubRouteGroup();
  const { data } = useGetWorkOrderRoutingGroup(groupId);

  const isLoading = isCreateLoading || isUpdateLoading;
  const isSuccess = isCreateSuccess || isUpdateSuccess;
  const isEdit = typeof groupId === "number";

  useEffect(() => {
    isSuccess && onClose();
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const payload = {
      ...(isEdit ? { groupId } : { routeId }),
      userId: formData?.userId,
      stations: formData.stations?.map((s, idx) => ({
        ...(isEdit ? { routeId: s?.routeId || null } : {}),
        stationId: s.stationId,
        order: idx,
      })),
      quantity: Number(formData.quantity) || 1,
    };
    if (isEdit) update(payload);
    else if (routeId) create(payload);
  };

  const defaultValues = { userId, station: [], quantity: 0, ...data };

  return (
    <HubDialogContent largePadding>
      <HubHookFormWrapper onSubmit={onSubmit} defaultValues={defaultValues}>
        <Stack gap="35px">
          <Stack gap="10px" alignItems="center">
            <Stack alignItems="center" justifyContent="center">
              <Typography variant="h6">Flag Parts for Rework</Typography>
              <Typography variant="boldCaptionMain">
                (Markar Piezas Para Retrabajo)
              </Typography>
            </Stack>
            <Stack alignItems="center" justifyContent="center">
              <Typography
                variant="caption"
                sx={{ textAlign: "center", maxWidth: "450px" }}
              >
                You are about to create a new task for the quantity of parts you
                are selecting. This route will <strong>NOT</strong> be able to
                be finished while there are reworks still being completed.
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  textAlign: "center",
                  maxWidth: "450px",
                  fontWeight: 600,
                  color: "hubColors.mainFocus",
                }}
              >
                (Vas a crear una nueva tarea para la cantidad de piezas que está
                seleccionando. Esta ruta <strong>NO</strong> podrá completarse
                mientras haya piezas en proceso.)
              </Typography>
            </Stack>
          </Stack>
          <AddReworkRouteContentForm />
          <HubCancelSubmitGroup
            disabled={isLoading}
            isLoading={isLoading}
            label={
              isEdit
                ? "Update Rework (Modificar Retrabajo)"
                : "Create Rework (Markar para Retrabajo)"
            }
            overrideCancel={onClose}
            sx={{
              "#ModalDisplaySubmit": {
                padding: "5px 15px",
              },
            }}
          />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default AddReworkRouteContent;
